import React from 'react';

import './IntroBanner.scss';
import { src } from '../../helpers/image';
import { link } from '../../helpers/link';
import icons from '../../shared/assets/icons';

const { RightArrow } = icons;

export default function IntroBanner(props) {
  const { text, image, title, overlay, pagePath, nextLink, backgroundOffset } =
    props;

  return (
    <section id="introBanner">
      {pagePath && (
        <div id="introBanner_path">
          {pagePath.map((path, idx) => (
            <React.Fragment key={idx}>
              {link(<span>{path.label}</span>, path.link, nextLink)}
              {idx + 1 !== pagePath.length && <RightArrow />}
            </React.Fragment>
          ))}
        </div>
      )}

      <div
        id="introBanner_image"
        style={{
          backgroundImage: `url(${src(image, 800, 400)})`,
          backgroundPosition: `0 ${backgroundOffset}`
        }}
      >
        <div style={{ ...(overlay && { backgroundColor: overlay }) }}>
          <h2>{title}</h2>

          {text && <p>{text}</p>}
        </div>
      </div>
    </section>
  );
}
